import * as _ from 'lodash';
import { DMPhong } from './danhmuc/dmPhong';

type UserRole = string | Array<string>;
type UserMenu = string | Array<string>;

interface UserToken {
  [key: string]: any;
  domain: string;
  aud: string;
  exp: number;
  nbf: number;
  iss: string;
  menu: UserMenu;
  role: UserRole;
}

export class User {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  token: string;
  domain: string;
  role: string;
  groupId: string;
  static fromJSON(info: string): User {
    if (info === null) {
      return null;
    }

    try {
      const data = JSON.parse(info);
      const user = new User();
      return _.extend(user, data);
    } catch {
      return null;
    }
  }

  static from(info: object): User {
    return _.extend(new User(), info);
  }
}
